import React, {useEffect, useState} from 'react';
import Snackbar from "@mui/material/Snackbar";
import Stack from "@mui/material/Stack";
import MuiAlert from '@mui/material/Alert';
import {CircularProgress} from "@mui/material";
import Box from "@mui/material/Box";
import Sidebar from "./Sidebar";
import {Link, useHistory} from "react-router-dom";
import axios from "axios";


const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const ForgotPassword = () => {
    // DATA
    const history = useHistory();
    const autoHideAlert = 3000;
    const [phoneNumber, setPhoneNumber] = useState("");
    const [loading, setLoading] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [alertText, setAlertText] = useState("");
    const [alertType, setAlertType] = useState("error");
    const [token, setToken] = useState('');
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    //
    const [loadingSend, setLoadingSend] = useState(false);
    const [showTime, setShowTime] = useState(false);
    const [sendTokenTime, setSendTokenTime] = useState(0);

    // LOAD
    useEffect(() => {
        const phone_number = localStorage.getItem("login_phone_number")
        if (!phone_number) {
            history.push('/login');
        }
        setPhoneNumber(phone_number);
    }, []);

    useEffect(() => {
        if (showTime) {
            var token_time = 120;
            setSendTokenTime(token_time);
            let interval = setInterval(() => {
                token_time -= 1;
                setSendTokenTime(token_time);
                if (token_time <= 0) {
                    clearInterval(interval);
                    setShowTime(false);
                    setLoadingSend(false);
                }
            }, 1000);
        }
    }, [showTime]);
    // FUNCTION
    const Error = (text, error_type = "error") => {
        setShowAlert(true);
        setAlertText(text);
        setAlertType(error_type);
        setTimeout(() => {
            setShowAlert(false);
        }, autoHideAlert)
    }

    const sendToken = () => {
        setLoadingSend(true);
        axios.get(`https://zaminhost.com/api/forget-password?mobile=${phoneNumber}`).then((r) => {
            const result = r.data;
            if (result.status === 200) {
                setShowTime(true);
                setLoadingSend(false);
                return Error(result.msg, "success");
            } else {
                setLoadingSend(false);
                return Error(result.msg, "error");
            }
        }).catch((e) => {
            console.log(e)
            return Error("مشکلی پیش آمده است، لطفا دوباره امتحان کنید", "error");
        })
    }

    const submitForm = (e) => {
        e.preventDefault();
        if (password === "") {
            Error("لطفا کلمه عبور را وارد کنید");
        } else if (password2 === "") {
            Error("لطفا تکرار کلمه عبور را وارد کنید");
        } else if (password !== password2) {
            Error("لطفا کلمه عبور را درست تکرار کنید");
        } else {
            setLoading(true);
            const formData = new FormData();
            formData.append("mobile", phoneNumber);
            formData.append("code", token);
            formData.append("password", password);
            axios.post("https://zaminhost.com/api/forget-password", formData).then((r) => {
                const result = r.data;
                if (result.status === 200) {
                    Error(result.msg, "success");
                    setTimeout(() => {
                        return window.location.replace("/login");
                    }, 2000);
                } else {
                    setLoading(false);
                    return Error(result.msg);
                }
            }).catch((e) => {
                console.log(e);
            })
        }
    }


    // JSX
    return (
        <div className='row mx-0 px-0 '>
            {/* **************** TITLE **************** */}
            <div className="col-12 col-md-6 px-0">
                <Sidebar/>
            </div>
            {/* **************** FORM **************** */}
            <div className="col-12 col-md-6 px-0">
                {loading ?
                    <div className="h-full h-md-fit d-flex justify-content-center align-items-center mt-5 my-md-0">
                        <Box sx={{display: 'flex', marginRight: '20px'}}>
                            <CircularProgress/>
                        </Box>
                    </div> :
                    <form method="post" onSubmit={submitForm}
                          className="h-full h-md-fit d-flex justify-content-center align-items-center mt-5 my-md-0">
                        <div style={{width: "65%"}}>
                            <div>
                                <label htmlFor="forgot_token" className="form-label fs-2">کد ۵ رقمی ارسال شده
                                    به {phoneNumber}</label>
                                <div className="d-flex justify-content-between align-items-center">
                                    <button className={"btn text-nowrap btn-primary me-5"} type="button"
                                            disabled={loadingSend || showTime} onClick={sendToken}>
                                        {loadingSend ? <>
                                            <Box>
                                                <CircularProgress
                                                    style={{'width': "15px", "height": "15px", "color": "#fff"}}/>
                                            </Box>
                                        </> : <>
                                            {showTime ? <>{sendTokenTime}</> : <>ارسال کد</>}
                                        </>}
                                    </button>
                                    <input type="tel" id="forgot_token"
                                           className="form-control login-input direction-ltr"
                                           placeholder="12345" onChange={(e) => {
                                        setToken(e.target.value)
                                    }} value={token}/>
                                </div>
                            </div>
                            <hr/>
                            <label htmlFor="login_password" className="form-label fs-2">کلمه عبور جدید:</label>
                            <input type="password" id="login_password"
                                   className="form-control login-input direction-ltr"
                                   placeholder="*********" onChange={(e) => {
                                setPassword(e.target.value)
                            }} value={password}/>
                            <label htmlFor="login_password_2" className="form-label fs-2 mt-5">تکرار کلمه عبور:</label>
                            <input type="password" id="login_password_2"
                                   className="form-control login-input direction-ltr"
                                   placeholder="*********" onChange={(e) => {
                                setPassword2(e.target.value)
                            }} value={password2}/>
                            <button className="btn btn-primary mt-5">ارسال</button>
                            <Link to="/login-password"
                                  className="btn btn-light-primary fw-bolder mt-5 ms-3">بازگشت</Link>
                        </div>
                    </form>
                }
            </div>
            {/* **************** ALERT **************** */}
            {showAlert && <Stack spacing={2} sx={{width: '100%'}}>
                <Snackbar open={true}
                          autoHideDuration={autoHideAlert}
                          style={{width: "320px"}}
                          anchorOrigin={{vertical: 'top', horizontal: 'right'}}>
                    <Alert severity={alertType} sx={{width: '100%'}}>
                                                <span className={"yekan-font"}>
                                                    {alertText}
                                                </span>
                    </Alert>
                </Snackbar>
            </Stack>}
        </div>
    )
}

export default ForgotPassword;
